import { Col, FloatingLabel, FormCheck, FormControl, Row } from "react-bootstrap";
import Validator from "../../../../services/Validator";
import CommonUtils from "../../../../utils/common";
import { MdAttachFile } from "react-icons/md";
import EnergoTooltip from "../../../shared/EnergoTooltip";

const AbrechnungMask = ({data, setData, formError, setFormError}) => {

    const VALIDATOR = new Validator();
    const UTILS = new CommonUtils();

    const noUidCheckHandler = (isChecked) => {
        setFormError({});
        setData(prev => ({...prev, noUid: isChecked}));
        if (isChecked) setData(prev => ({...prev, uid: ""}));
    };


    const addToFileList = (file) => {
        setFormError({});
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setData(prev => ({
                ...prev,
                vollmacht: ({ file_name: file.name, file: reader.result.split(",")[1] })
            }));
        }
    }

    const noVollmachtCheckHandler = (isChecked) => {
        setFormError({});
        setData(prev => ({
            ...prev, 
            noVollmacht: isChecked
        }));

        if (isChecked) setData(prev => ({...prev, vollmacht: ({})}));
    }

    return (
        <>
            <p className="text-muted">
                <small>Zahlungsinformation</small>
            </p>
            <Row className="align-items-center">
                <Col xs="12" md="6" xl="4" hidden={data.noUid}>
                    <FloatingLabel label="UID-Nummer">
                        <FormControl
                            placeholder="UID-Nummer"
                            value={data.uid}
                            onChange={e => {setData(prev => ({...prev, uid: e.target.value})); setFormError({})}}
                            isValid={VALIDATOR.vatValid(data.uid)}
                            isInvalid={formError.uid}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="6" xl="8">
                    <FormCheck
                        label="Keine UID-Nummer vorhanden"
                        defaultChecked={data.noUid}
                        onChange={e => noUidCheckHandler(e.target.checked)}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12" md="6" xl="6">
                    <FloatingLabel label="Kontoinhaber">
                        <FormControl
                            placeholder="Kontoinhaber"
                            value={data.building_account_owner}
                            onChange={e => {setData(prev => ({...prev, building_account_owner: e.target.value})); setFormError({})}}
                            isValid={data.building_account_owner && data.building_account_owner.length > 3}
                            isInvalid={formError.building_account_owner}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="6" xl="6">
                    <FloatingLabel label="IBAN">
                        <FormControl
                            placeholder="IBAN"
                            value={data.building_iban}
                            onChange={e => {setData(prev => ({...prev, building_iban: UTILS.ibanHandler(e.target.value)})); setFormError({})}}
                            isValid={VALIDATOR.ibanValid(data.building_iban.replace(/\s+/g, ''))}
                            isInvalid={formError.building_iban}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs="12" md="8" xl="5">
                    <p className="text-muted"><small>Verwaltungsinformationen</small></p>
                    <FloatingLabel label="Datum Poolbeitritt / Datum der Verwaltungsübernahme">
                        <FormControl
                            type="date"
                            placeholder="Datum Poolbeitritt / Datum der Verwaltungsübernahme"
                            value={data.pool_start}
                            onChange={e => {setData(prev => ({...prev, pool_start: e.target.value})); setFormError({})}}
                            isValid={data.pool_start && data.pool_start !== ""}
                            isInvalid={formError.pool_start}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-4 align-items-center">
                <Col xs="12" md="6" xl="4" hidden={data.noVollmacht}>
                    <input id="attachmentField" type="file" hidden onChange={e => addToFileList(e.target.files[0])} />
                    {data.vollmacht.file_name ?
                        <p className="text-energo">{data.vollmacht.file_name}</p>
                        :
                        <div className="d-flex">
                            <a 
                                onClick={e => {e.preventDefault(); document.getElementById('attachmentField').click()}}
                                href="/upload" 
                                className="link-energo"
                                style={formError.vollmacht ? {border: "1px solid red", padding: 8, marginRight: 10}: {marginRight: 10}}
                            >
                                <MdAttachFile size={25} /> Verwaltungsvollmacht uploaden
                            </a>
                            <EnergoTooltip position="top" tKey="8002" />
                        </div>
                    }
                </Col>
                <Col xs="12" md={data.noVollmacht? "12": "6"} xl={data.noVollmacht? "12":"8"}>
                    <FormCheck
                        label="Es liegt noch keine Vollmacht vor. Diese wird später nachgereicht"
                        defaultChecked={data.noVollmacht}
                        onChange={e => noVollmachtCheckHandler(e.target.checked)}
                    />
                </Col>
            </Row>
        </>
    )
}
export default AbrechnungMask;